import { user, checkout } from 'core/use-cases';
import {
  AvailableCredit,
  Values,
} from 'ui/components/templates/Checkout/Views/Summary/components/Summary.components.styles';
import { SummaryValues, Text } from 'ui/components';

const PaymentHeader = () => {
  const {
    data: { values },
  } = checkout.hooks.useSummary();

  const { data: userData } = user.hooks.useUserCredit();
  const availableCredit = userData.available;

  return (
    <>
      <Values.Payment>
        <SummaryValues bankSlipEmission={false} dataMargin="sm" values={values} />
      </Values.Payment>

      <AvailableCredit.Card spacing="small">
        <Values.Row
          data-spacing="none"
          tabIndex={0}
          aria-label={`Crédito disponível ${availableCredit}`}
        >
          <Text>Crédito disponível</Text>
          <Text>{availableCredit}</Text>
        </Values.Row>
      </AvailableCredit.Card>
    </>
  );
};

export default PaymentHeader;
